/* unplugin-vue-components disabled */import script from "./AddChildTeamModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddChildTeamModal.vue?vue&type=script&setup=true&lang=js"

import "./AddChildTeamModal.vue?vue&type=style&index=0&id=87f08790&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87f08790"]])

export default __exports__